/**
 * @generated SignedSource<<1df8aca6ead5bc7e90a9b43f1fdda72c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CategoryButtonFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "BlogCategoryNode",
  "abstractKey": null
};

node.hash = "18d91300925987d9e4a8591173fd46ed";

module.exports = node;
